<template>
  <v-app>
    <div class="oauth-complete">
      <v-progress-circular indeterminate color="pink" />
      <p v-if="error" class="error-text mt-3">{{ error }}</p>
    </div>
  </v-app>
</template>

<script>
import GlobalRequest from "@/plugins/globalRequest";

export default {
  name: "BitrixOAuthComplete",
  data() {
    return {
      error: "",
    };
  },
  async mounted() {
    const { token, refreshToken, userId } = this.$route.query;

    if (!token || !refreshToken || !userId) {
      this.error = "Не удалось завершить авторизацию через Битрикс24";
      return;
    }

    const expires = new Date(Date.now() + 30 * 60 * 1000).toUTCString();
    document.cookie = `token=${token};expires=${expires};path=/;`;
    document.cookie = `refresh_token=${refreshToken};expires=${expires};path=/;`;

    const userResponse = await GlobalRequest.request("/user/" + userId, "GET");

    if (!userResponse || !userResponse.success) {
      this.error = "Не удалось получить данные пользователя";
      return;
    }

    const user = userResponse.data;

    localStorage.setItem("current_user", JSON.stringify(user.id));
    localStorage.setItem("role", JSON.stringify(user.roles));
    localStorage.setItem("head", user.subordinates && user.subordinates.length > 0 ? true : false);

    const redirect = localStorage.getItem("after_login_redirect");
    localStorage.removeItem("after_login_redirect");

    this.$router.replace(redirect && redirect !== "/authentication" ? redirect : "/profile");
  },
};
</script>

<style scoped>
.oauth-complete {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.error-text {
  color: #d32f2f;
}
</style>
